import React from "react";
import {
  Box,
  Button,
  Chip,
  Container,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { Facebook, Instagram, LinkedIn, Twitter } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { APP_VERSION } from "../config/version";

const socialLinks = [
  {
    icon: Facebook,
    url: "https://www.facebook.com/profile.php?id=61586741157245",
    label: "Facebook",
  },
  {
    icon: Twitter,
    url: "https://x.com/MedAxisPlus",
    label: "X",
  },
  {
    icon: Instagram,
    url: "https://www.instagram.com/medaxisplus/",
    label: "Instagram",
  },
  {
    icon: LinkedIn,
    url: "https://www.linkedin.com/in/medaxis-support-17643b39b/",
    label: "LinkedIn",
  },
];

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        display: { xs: "none", md: "block" },
        mt: { xs: 5, md: 7 },
        pb: { xs: 12, md: 0 },
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            p: { xs: 3, md: 4.5 },
            borderRadius: { xs: "28px", md: "32px" },
            bgcolor: "rgba(15, 23, 42, 0.96)",
            color: "white",
            boxShadow: "0 28px 70px rgba(15, 23, 42, 0.16)",
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} md={5}>
              <Chip
                label="VenTush"
                sx={{
                  mb: 2,
                  bgcolor: "rgba(255,255,255,0.12)",
                  color: "white",
                }}
              />
              <Typography variant="h3" sx={{ mb: 1.2, color: "white" }}>
                Designed to remember what matters.
              </Typography>
              <Typography sx={{ color: "rgba(255,255,255,0.74)", maxWidth: 460 }}>
                VenTush keeps deadlines, milestones, appointments, and recurring
                celebrations visible in one elegant, low-stress workspace.
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="h5" sx={{ color: "white", mb: 1.5 }}>
                Explore
              </Typography>
              <Stack spacing={1}>
                {[
                  { label: "Dashboard", to: "/" },
                  { label: "Priority", to: "/favourite" },
                  { label: "Add Date", to: "/add" },
                  { label: "Calendar", to: "/calendar" },
                  { label: "About", to: "/about" },
                ].map((item) => (
                  <Button
                    key={item.to}
                    component={RouterLink}
                    to={item.to}
                    color="inherit"
                    sx={{ justifyContent: "flex-start", px: 0 }}
                  >
                    {item.label}
                  </Button>
                ))}
              </Stack>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="h5" sx={{ color: "white", mb: 1.5 }}>
                Stay connected
              </Typography>
              <Typography sx={{ color: "rgba(255,255,255,0.74)", mb: 2 }}>
                medaxisplus@gmail.com
              </Typography>
              <Stack direction="row" spacing={1}>
                {socialLinks.map(({ icon: Icon, url, label }) => (
                  <IconButton
                    key={label}
                    component="a"
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    sx={{
                      color: "white",
                      bgcolor: "rgba(255,255,255,0.08)",
                      "&:hover": {
                        bgcolor: "primary.main",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <Icon />
                  </IconButton>
                ))}
              </Stack>
            </Grid>
          </Grid>

          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={1}
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", md: "center" }}
            sx={{
              mt: 4,
              pt: 2.5,
              borderTop: "1px solid rgba(255,255,255,0.12)",
              color: "rgba(255,255,255,0.62)",
            }}
          >
            <Typography variant="body2">
              © {new Date().getFullYear()} VenTush • v{APP_VERSION}
            </Typography>
            <Typography variant="body2">
              Calm planning for exams, medical visits, legal milestones, and life events.
            </Typography>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
